"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowTextEditor_1 = require("../../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowTextAreaEditor_1 = require("../../../../../../../shared/components/editors/CardRowTextAreaEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var PlayerLevelOfferEditor = /** @class */ (function (_super) {
    __extends(PlayerLevelOfferEditor, _super);
    function PlayerLevelOfferEditor(props) {
        return _super.call(this, props) || this;
    }
    PlayerLevelOfferEditor.prototype.getPriorityAvail = function () {
        var _ret = [];
        for (var i = 1; i <= 10; i++) {
            _ret.push({
                key: i,
                value: "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442-" + i,
            });
        }
        return _ret;
    };
    PlayerLevelOfferEditor.prototype.componentWillMount = function () {
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_language_id: _item.app_language_id,
                    app_language_title: _item.app_language_title,
                    title: _item.title,
                    offer_text: _item.offer_text,
                    is_locked: _item.is_locked,
                    priority_key: this.props.record.priority,
                    priority_val: "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442-" + this.props.record.priority,
                    priority_avail: this.getPriorityAvail()
                });
            }
        }
        else {
            this.setState({
                app_language_id: 0,
                app_language_title: "",
                title: "",
                offer_text: "",
                is_locked: false,
                priority_key: 1,
                priority_val: "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442-" + 1,
                priority_avail: this.getPriorityAvail(),
            });
        }
        this.doReSetRules();
    };
    PlayerLevelOfferEditor.prototype.doReSetRules = function () {
        this.setState({
            app_language_rules: { isError: false },
            title_rules: { isError: false },
            priority_rules: { isError: false }
        });
    };
    PlayerLevelOfferEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_language_id <= 0) || (this.state.app_language_title.length === 0)) {
            this.setState({ app_language_rules: { isError: true, errorMessage: "Язык не выбран!" } });
            return false;
        }
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Название не заполнено!" } });
            return false;
        }
        if ((!this.state.offer_text) || (this.state.offer_text.length === 0)) {
            this.setState({ offer_text_rules: { isError: true, errorMessage: "Оффер не заполнен!" } });
            return false;
        }
        if ((this.state.priority_key <= 0) || (this.state.priority_val.length === 0)) {
            this.setState({
                priority_rules: { isError: true, errorMessage: "Поле [приоритет] не выбрано!" }
            });
            return false;
        }
        return true;
    };
    PlayerLevelOfferEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                app_language_id: this.state.app_language_id,
                title: this.state.title,
                offer_text: this.state.offer_text,
                priority: this.state.priority_key,
                is_locked: this.state.is_locked
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Оффер уровня изменен!");
            });
        }
    };
    PlayerLevelOfferEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_language_id: this.state.app_language_id,
                brand_bonus_level_id: this.props.rootRecord.key,
                title: this.state.title,
                offer_text: this.state.offer_text,
                priority: this.state.priority_key,
                is_locked: this.state.is_locked
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Оффер уровня добавлен!");
            });
        }
    };
    PlayerLevelOfferEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PlayerLevelOfferEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новый оффер уровня";
        }
        else {
            return "Изменить оффер уровня";
        }
    };
    PlayerLevelOfferEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 580 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык:", placeholder: "Выберите язык" }, value: { key: this.state.app_language_id, value: this.state.app_language_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_language_id: newVal.key,
                        app_language_title: newVal.value,
                        app_language_rules: { isError: false }
                    });
                }, items: this.props.availLanguages, required: true, rules: this.state.app_language_rules }),
            React.createElement(CardRowTextAreaEditor_1.default, { texts: { caption: "Оффер уровня:", placeholder: "Введите текст оффера уровня" }, value: this.state.offer_text, onValueChanged: function (newVal) {
                    _this.setState({ offer_text: newVal });
                }, rowsCount: 8, required: true, rules: this.state.offer_text_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Приоритет:", placeholder: "Выберите приоритет" }, value: { key: this.state.priority_key, value: this.state.priority_val }, onValueChanged: function (newVal) {
                    _this.setState({
                        priority_key: newVal.key,
                        priority_val: newVal.value,
                        priority_rules: { isError: false }
                    });
                }, items: this.state.priority_avail, required: true, rules: this.state.priority_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Оффер заблокирован", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return PlayerLevelOfferEditor;
}(React.Component));
exports.default = PlayerLevelOfferEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_player_levels/ui/component/cfg_offers/PlayerLevelOffersEditor.tsx
// module id = 1957
// module chunks = 0